module.exports = __webpack_public_path__ + "media/assets/images/logo-citro-suco-e9fdd468fe27100d08e41074ce8f5867.png";